import DropdownSelectorSystem from './DropdownSelectorSystem';
import './DropdownSelectorSystem.scss';

export default DropdownSelectorSystem;
